import { requestListBakul, requestListTotalBakul, requestSaveFieldValues, requestSyncBakul } from '../../interface';
import { APICore } from '../apiCore';

const api = new APICore();

function GetSyncBakul(params: requestSyncBakul, signal: AbortSignal) {
    return api.get('/api/v1/profiling/bakul/sync-bakul-from-erp', params, { signal });
}

function GetListTotalBakul(params: requestListTotalBakul, signal: AbortSignal) {
    return api.get('/api/v1/profiling/bakul/total-bakul', params, { signal });
}

function GetListBakul(params: requestListBakul, signal: AbortSignal) {
    return api.get('/api/v1/profiling/bakul/list', params, { signal });
}

function GetListApCabang(params: { perusahaan_id: number; cabang_id: number; bakul_id: number }, signal: AbortSignal) {
    return api.get(`/api/v1/profiling/bakul/list-ap-cabang`, params, { signal });
}

function GetDetailBakul(perusahaan_id: number, bakul_id: number, params: { cabang_id: number }, signal: AbortSignal) {
    return api.get(`/api/v1/profiling/bakul/identity/${perusahaan_id}/${bakul_id}`, params, { signal });
}

function GetOverviewBakul(perusahaan_id: number, bakul_id: number, params: { cabang_id: number }, signal: AbortSignal) {
    return api.get(`/api/v1/profiling/bakul/overview/${perusahaan_id}/${bakul_id}`, params, { signal });
}

function GetDetailPiutangBakul(
    perusahaan_id: number,
    bakul_id: number,
    params: { cabang_id: number },
    signal: AbortSignal
) {
    return api.get(`/api/v1/profiling/bakul/detail-piutang/${perusahaan_id}/${bakul_id}`, params, { signal });
}

function GetDetailTransaksiBakul(
    perusahaan_id: number,
    bakul_id: number,
    params: { cabang_id: number },
    signal: AbortSignal
) {
    return api.get(`/api/v1/profiling/bakul/detail-transaksi/${perusahaan_id}/${bakul_id}`, params, { signal });
}

function GetFrekuensiPengambilan(
    perusahaan_id: number,
    bakul_id: number,
    params: { filter: string },
    signal: AbortSignal
) {
    return api.get(`/api/v1/profiling/bakul/frekuensi-pengambilan/${perusahaan_id}/${bakul_id}`, params, { signal });
}

function GetPiutangBakul(perusahaan_id: number, bakul_id: number, params: { filter: string }, signal: AbortSignal) {
    return api.get(`/api/v1/profiling/bakul/piutang-chart/${perusahaan_id}/${bakul_id}`, params, { signal });
}

function GetFormTemplateCRM(params: {}, signal?: AbortSignal) {
    return api.get('/api/v1/crm/bakul/form/template', params, { signal });
}

function GetFormByIdCRM(bakul_id: number, signal?: AbortSignal) {
    return api.get(`/api/v1/crm/bakul/form/complete/bakul/${bakul_id}`, undefined, { signal });
}

function saveFieldValuesCRM(payload: requestSaveFieldValues) {
    return api.create('/api/v1/crm/bakul/form/complete/section/save', payload);
}

function GetBakulIdCRM(params: { company_id: number; bakul_id: number }, signal?: AbortSignal) {
    return api.get('/api/v1/crm/bakul/crm-bakul-id', params, { signal });
}

export {
    GetSyncBakul,
    GetListBakul,
    GetBakulIdCRM,
    GetDetailBakul,
    GetFormByIdCRM,
    GetPiutangBakul,
    GetListApCabang,
    GetOverviewBakul,
    GetListTotalBakul,
    GetFormTemplateCRM,
    saveFieldValuesCRM,
    GetDetailPiutangBakul,
    GetDetailTransaksiBakul,
    GetFrekuensiPengambilan,
};
